var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{on:{"click":_vm.onToggle}},[_vm._v(_vm._s(_vm.show ? 'DESTROY' : 'SHOW'))]),(_vm.show)?_c('CalendarTooltipTests'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }